import { Component, Input } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {CTATypes, Language} from "../../model/common.enum";
import {StorageService} from "../../services/storage.service";

@Component({
  selector: 'rch-language-toggle',
  templateUrl: './language-toggle.component.html',
  styleUrls: ['./language-toggle.component.scss']
})
export class LanguageToggleComponent {
  @Input() variant: string = CTATypes.PRIMARY;
  currentLang = Language.EN.toString();
  langLabel = Language.FR;

  constructor(
    private storageService: StorageService,
    private translateService: TranslateService
  ) {
    const lang = this.storageService.getLanguage();
    this.currentLang = lang ? lang : Language.EN;
  }

  toggleLang() {
    this.langLabel = this.currentLang === Language.EN ? Language.EN : Language.FR;
    this.currentLang = this.currentLang === Language.EN ? Language.FR : Language.EN;
    this.translateService.use(this.currentLang);
    this.storageService.setLanguage(this.currentLang);
  }

}
